import { ASIAN_MARKETS } from 'utils/constants/sportsbook/asian-market-names';
import { Market } from 'interfaces/sportsbook-data-levels';

export const getMarketType = ({ name, type }: Market): string => {
  return ASIAN_MARKETS[name] || type || '';
};
